import { LoopMappingProperty } from '../services/api/generated';

export type Property = {
  propertyId: number;
  propertyName: string;
  propertyKey: string;
  propertyOrderNumber: number;
  propertyDescription: string;
  propertyExample: string;
};

export type Category = {
  categoryId: number;
  categoryName: string;
  categoryKey: string;
  categoryOrderNumber: number;
  mappingRestriction: string;
  properties: Property[];
};

export type DataCatalog = {
  categories: Category[];
  createdAt: string;
  updatedAt: string;
};

export type MappingProperty = {
  propertyId: number;
  propertyName: string;
  propertyKey: string;
  categoryKey: string;
  rowIndex: number;
  colIndex: number;
  targetCell: string;
  categoryId: number;
  mappingRestriction: string;
};

export type LoopRange = {
  startRowIndex: number;
  endRowIndex: number;
  startColIndex: number;
  endColIndex: number;
  loopRangeTargetCell: string;
};

export type Loop = {
  loopId: number;
  loopCount: number;
  loopRange: LoopRange;
  loopHeaderRange: string;
  categoryId: number;
  mappingRestriction: string;
};

// 画面用の型定義
export type Option = {
  value: string;
  label: string;
};

export type PropertyView = Property & {
  categoryKey: string;
  categoryId: number;
  mappingRestriction: string;
};

export const RESULT = {
  SUCCESS: 'success',
  FAILED: 'failed',
  SKIPPED: 'skipped',
} as const;
export type Result = (typeof RESULT)[keyof typeof RESULT];

export type LoopId = number;

// SpreadJSのtagに格納する情報
export type PropertyTag = {
  propertyId: number;
  propertyName: string;
  propertyKey: string;
  categoryKey: string;
  categoryId: number;
  mappingRestriction: string;
};

export type LoopTag = {
  start?: LoopId;
  end?: LoopId;
  headerEnd?: LoopId;
};

export type CellTag = {
  property?: PropertyTag;
  loop?: LoopTag;
};

export type CollectedProperty = PropertyTag & {
  rowIndex: number;
  colIndex: number;
  targetCell: string;
};

export type ExtentionLoopMappingProperty = Omit<
  LoopMappingProperty,
  'mappingProperties'
> & {
  mappingProperties?: Array<CollectedProperty>;
};
